import getAtlasIdentityCookie from "./get-atlas-identity-cookie";

export default function getAuthHeaders(appId: string, cookie?: string) {
  const { userId, userHash } = getAtlasIdentityCookie(appId, cookie);

  return {
    "x-atlas-account-id": appId,
    ...(userId && { "x-atlas-user-id": userId }),
    ...(userHash && { "x-atlas-user-hash": userHash }),
  };
}
